// slides

const takeoverSlider = new Swiper('.takeover', {
  slidesPerView: 1,
  speed: 500,
  autoplay: {
    delay: 5000,
    disableOnInteraction: false,
    pauseOnMouseEnter: true,
  },
  loop: true,
  effect: 'fade',
  fadeEffect: {
    crossFade: true
  },
  navigation: {
    nextEl: '.takeover-next',
    prevEl: '.takeover-prev',
  },
  pagination: {
    el: '.takeover-pagination',
    clickable: 'true'
  }
});

const collectionSlider = new Swiper('.collection-slider', {
  slidesPerView: 1,
  // spaceBetween: 10,
  speed: 500,
  autoplay: {
    delay: 6000,
    disableOnInteraction: false,
    pauseOnMouseEnter: true,
  },
  navigation: {
    nextEl: '.collection-slider-next',
    prevEl: '.collection-slider-prev',
  },
  breakpoints: {
    480: {
      slidesPerView: 1
    },
    640: {
      slidesPerView: 2
    },
    860: {
      slidesPerView: 3
    }
  },
});

const productSlider = new Swiper('.product-slider-block', {
  slidesPerView: 2,
  spaceBetween: 20,
  speed: 500,
  autoplay: {
    delay: 5000
  },
  navigation: {
    nextEl: ".product-slider-next",
    prevEl: ".product-slider-prev",
  },
  breakpoints: {
    320: {
      slidesPerView: 2,
      spaceBetween: 20,
    },
    480: {
      slidesPerView: 3,
      spaceBetween: 20,
    },
    720: {
      slidesPerView: 4,
      spaceBetween: 20,
    },
    960: {
      slidesPerView: 6,
      spaceBetween: 20,
    }
  },
});

// product thumb shots
const swiperProductGallery = new Swiper('.product-gallery', {
  spaceBetween: 10,
  slidesPerView: 2,
  // freeMode: true,
  watchSlidesProgress: true,
  navigation: {
    nextEl: ".product-gallery-next",
    prevEl: ".product-gallery-prev",
  },
  breakpoints: {
    320: {
      slidesPerView: 2
    },
    480: {
      slidesPerView: 3
    },
    640: {
      slidesPerView: 3
    },
    860: {
      slidesPerView: 4
    }
  },
});
// main product shot
const swiperProductShot = new Swiper('.product-shot', {
  effect: 'fade',
  fade: {
    crossFade: true 
  },
  thumbs: {
    swiper: swiperProductGallery,
  },
  navigation: {
    nextEl: '.product-shot-slider-next',
    prevEl: '.product-shot-slider-prev',
  },
});

// media gallery swiper
const mediaSlider = new Swiper('.media-gallery', {
  slidesPerView: 4,
  // spaceBetween: 10,
  loop: true,
  speed: 500,
  autoplay: {
    delay: 5000,
  },
  navigation: {
    nextEl: '.media-gallery-arrow.next',
    prevEl: '.media-gallery-arrow.prev',
  },
  breakpoints: {
    320: {
      slidesPerView: 1
    },
    480: {
      slidesPerView: 2
    },
    640: {
      slidesPerView: 3
    },
    960: {
      slidesPerView: 4,
      // spaceBetween: 20
    },
    1024: {
      slidesPerView: 5,
      // spaceBetween: 20
    }
  },
});

var forEach=function(t,o,r){if("[object Object]"===Object.prototype.toString.call(t))for(var c in t)Object.prototype.hasOwnProperty.call(t,c)&&o.call(r,t[c],c,t);else for(var e=0,l=t.length;l>e;e++)o.call(r,t[e],e,t)};

const hamburgers = document.querySelectorAll(".hamburger");
const mobileMenu = document.querySelector(".mobile-menu");

if (hamburgers.length > 0) {
  forEach(hamburgers, function(hamburger) {
    hamburger.addEventListener("click", function() {
      this.classList.toggle("is-active");
      mobileMenu.classList.toggle("is-active");
    }, false);
  });
}

async function updateCart() {
  const res = await fetch("/?section_id=cart-items");
  const text = await res.text();
  const html = document.createElement("div");
  html.innerHTML = text;

  const newBox = html.querySelector(".cart-items").innerHTML;

  document.querySelector(".cart-items").innerHTML = newBox;
}

jQuery( document ).ready( function( $ ) {

  // cart page upsell
  $('#cart-items').on('click', '.combo-box button', function(e) {
    e.preventDefault();
    var upsellId = $( this ).closest( '.upsell' ).data( 'upsell_id' );
    console.log('upsell clicked', upsellId);
    
    CartJS.addItem(upsellId, '1', {}, {
      success: function(data, textStatus, jqXHR) {
        jQuery.getJSON('/cart.js', function(cart) {
          location.reload();
          updateCart();
        });          
      },
      error: function(jqXHR, textStatus, errorThrown) {
        console.log("Error: " + errorThrown + "!");
      },
    });
  });

  // halt # execution
  $( '.header__nav  a[href="#"]' ).on( 'click', function( e ) {
    e.preventDefault();
  } );

  $('.nav-search').on('click', function(e) {
    e.preventDefault();
    $('.search-box').toggleClass('is-active');
    $('.search__input').focus();
  } );
  $('.close-search').on('click', function(e) {
    e.preventDefault();
    $('.search-box').toggleClass('is-active');
    $('.predictive-search').toggleClass('is-active');
  } );

  $(document).keydown(function(e){
    if(e.keyCode == 27) {
      if ($('.predictive-search-results').css('display') == 'flex') {
        $('.predictive-search-results').css('display', 'none');
      }
      if ($('.search-box').hasClass('is-active')) {
          $('.search-box').removeClass('is-active');
      }
    }
  });

  // magnific popup
  $('.gallery').each(function() {
    $(this).magnificPopup({
      delegate: 'a', // the selector for gallery item
      type: 'image',
      gallery: {
        enabled: true,
        navigateByImgClick: true,
        preload: [0,1]
      },
      image: {
        tError: '<a href="%url%">The image #%curr%</a> could not be loaded.',
      }
    });
  });

  $('.has-children a').on('click', function(e) {
    e.preventDefault();
    $(this).parent().toggleClass('is-active');
  });

});

// js/common/form/price-range.js
var PriceRange = class extends HTMLElement {
  #abortController;
  connectedCallback() {
    this.#abortController = new AbortController();
    const rangeLowerBound = this.querySelector('input[type="range"]:first-child'), rangeHigherBound = this.querySelector('input[type="range"]:last-child'), textInputLowerBound = this.querySelector('input[name="filter.v.price.gte"]'), textInputHigherBound = this.querySelector('input[name="filter.v.price.lte"]');
    textInputLowerBound.addEventListener("focus", () => textInputLowerBound.select(), { signal: this.#abortController.signal });
    textInputHigherBound.addEventListener("focus", () => textInputHigherBound.select(), { signal: this.#abortController.signal });
    textInputLowerBound.addEventListener("change", (event) => {
      event.preventDefault();
      event.target.value = Math.max(Math.min(parseInt(event.target.value), parseInt(textInputHigherBound.value || event.target.max) - 1), event.target.min);
      rangeLowerBound.value = event.target.value;
      rangeLowerBound.parentElement.style.setProperty("--range-min", `${parseInt(rangeLowerBound.value) / parseInt(rangeLowerBound.max) * 100}%`);
    }, { signal: this.#abortController.signal });
    textInputHigherBound.addEventListener("change", (event) => {
      event.preventDefault();
      event.target.value = Math.min(Math.max(parseInt(event.target.value), parseInt(textInputLowerBound.value || event.target.min) + 1), event.target.max);
      rangeHigherBound.value = event.target.value;
      rangeHigherBound.parentElement.style.setProperty("--range-max", `${parseInt(rangeHigherBound.value) / parseInt(rangeHigherBound.max) * 100}%`);
    }, { signal: this.#abortController.signal });
    rangeLowerBound.addEventListener("change", (event) => {
      event.stopPropagation();
      textInputLowerBound.value = event.target.value;
      textInputLowerBound.dispatchEvent(new Event("change", { bubbles: true }));
    }, { signal: this.#abortController.signal });
    rangeHigherBound.addEventListener("change", (event) => {
      event.stopPropagation();
      textInputHigherBound.value = event.target.value;
      textInputHigherBound.dispatchEvent(new Event("change", { bubbles: true }));
    }, { signal: this.#abortController.signal });
    rangeLowerBound.addEventListener("input", (event) => {
      event.target.value = Math.min(parseInt(event.target.value), parseInt(textInputHigherBound.value || event.target.max) - 1);
      event.target.parentElement.style.setProperty("--range-min", `${parseInt(event.target.value) / parseInt(event.target.max) * 100}%`);
      textInputLowerBound.value = event.target.value;
    }, { signal: this.#abortController.signal });
    rangeHigherBound.addEventListener("input", (event) => {
      event.target.value = Math.max(parseInt(event.target.value), parseInt(textInputLowerBound.value || event.target.min) + 1);
      event.target.parentElement.style.setProperty("--range-max", `${parseInt(event.target.value) / parseInt(event.target.max) * 100}%`);
      textInputHigherBound.value = event.target.value;
    }, { signal: this.#abortController.signal });
  }
  disconnectedCallback() {
    this.#abortController.abort();
  }
};
if (!window.customElements.get("price-range")) {
  window.customElements.define("price-range", PriceRange);
}

// js/common/utilities/dom.js
function throttle(callback) {
  let requestId = null, lastArgs;
  const later = (context) => () => {
    requestId = null;
    callback.apply(context, lastArgs);
  };
  const throttled = (...args) => {
    lastArgs = args;
    if (requestId === null) {
      requestId = requestAnimationFrame(later(this));
    }
  };
  throttled.cancel = () => {
    cancelAnimationFrame(requestId);
    requestId = null;
  };
  return throttled;
}
function debounce(fn, delay) {
  let timer = null;
  return (...args) => {
    clearTimeout(timer);
    timer = setTimeout(() => {
      fn.apply(this, args);
    }, delay);
  };
}
function waitForEvent(element, eventName) {
  return new Promise((resolve) => {
    const done = (event) => {
      if (event.target === element) {
        element.removeEventListener(eventName, done);
        resolve(event);
      }
    };
    element.addEventListener(eventName, done);
  });
}
